import { render, staticRenderFns } from "./zones.vue?vue&type=template&id=860a0e82&scoped=true&"
import script from "./zones.vue?vue&type=script&lang=js&"
export * from "./zones.vue?vue&type=script&lang=js&"
import style0 from "./zones.vue?vue&type=style&index=0&id=860a0e82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860a0e82",
  null
  
)

export default component.exports